const STREAK_KEY = 'hangrily_streak';

function getStreakData() {
  try {
    const saved = localStorage.getItem(STREAK_KEY);
    if (!saved) return { current: 0, best: 0, lastDate: null, todaySwipes: 0 };
    return JSON.parse(saved);
  } catch {
    return { current: 0, best: 0, lastDate: null, todaySwipes: 0 };
  }
}

function saveStreakData(data) {
  localStorage.setItem(STREAK_KEY, JSON.stringify(data));
}

const DAILY_GOAL = 5;

export function getStreak() {
  const data = getStreakData();
  const today = new Date().toDateString();
  const yesterday = new Date(Date.now() - 86400000).toDateString();

  // If last activity was before yesterday, streak is broken
  if (data.lastDate && data.lastDate !== today && data.lastDate !== yesterday) {
    data.current = 0;
    data.todaySwipes = 0;
    saveStreakData(data);
  }

  // If it's a new day, reset today's swipe count
  if (data.lastDate !== today) {
    data.todaySwipes = 0;
  }

  return {
    current: data.current,
    best: data.best,
    todaySwipes: data.todaySwipes,
    todayDone: data.todaySwipes >= DAILY_GOAL,
    goal: DAILY_GOAL,
    lastDate: data.lastDate,
  };
}

export function recordSwipe() {
  const data = getStreakData();
  const today = new Date().toDateString();
  const yesterday = new Date(Date.now() - 86400000).toDateString();

  // Reset streak if gap
  if (data.lastDate && data.lastDate !== today && data.lastDate !== yesterday) {
    data.current = 0;
  }

  // New day
  if (data.lastDate !== today) {
    data.todaySwipes = 0;
  }

  data.todaySwipes += 1;
  data.lastDate = today;

  // Check if daily goal just completed
  if (data.todaySwipes === DAILY_GOAL) {
    data.current += 1;
    if (data.current > data.best) {
      data.best = data.current;
    }
  }

  saveStreakData(data);
  return getStreak();
}

export function getDailyChallenge() {
  const streak = getStreak();
  const dayOfWeek = new Date().getDay();

  const challenges = [
    { emoji: '🌮', text: 'Try a cuisine you\'ve never picked before', bonus: 5 },
    { emoji: '💕', text: 'Do a couple session with your partner', bonus: 10 },
    { emoji: '🎲', text: 'Use Surprise Me and go with the result', bonus: 5 },
    { emoji: '⭐', text: 'Favorite 3 restaurants from your session', bonus: 5 },
    { emoji: '👥', text: 'Start a group session with 3+ friends', bonus: 15 },
    { emoji: '🔥', text: 'Complete 2 sessions today', bonus: 10 },
    { emoji: '📏', text: 'Find a restaurant within 1 mile', bonus: 5 },
  ];

  return {
    ...challenges[dayOfWeek],
    streak,
  };
}

export const DAILY_SWIPE_GOAL = DAILY_GOAL;
